import { createAction, createReducer, on } from '@ngrx/store';
import {
  cancelSharedReportEmail,
  sendSharedReportEmail,
  sharedReportEmailFailed,
  sharedReportEmailSucceeded
} from '@store/shared-report-email/shared-report-email.actions';
import { initialSharedReportEmailState } from '@store/shared-report-email/shared-report-email.model';
import { LOGOUT_SUCCESS } from '@store/user/user.actions';

export const sharedReportEmailReducer = createReducer(
  initialSharedReportEmailState,
  // Recipients, subject and message stay out of durable state; only correlation and status are kept.
  on(sendSharedReportEmail, (_state, { requestId }) => ({
    ...initialSharedReportEmailState,
    requestId,
    status: 'sending' as const
  })),
  on(sharedReportEmailSucceeded, (state, { requestId }) =>
    state.requestId === requestId && state.status === 'sending'
      ? { ...state, status: 'sent' as const, errorMessage: null }
      : state
  ),
  on(sharedReportEmailFailed, (state, { requestId, errorMessage }) =>
    state.requestId === requestId && state.status === 'sending'
      ? { ...state, status: 'error' as const, errorMessage }
      : state
  ),
  on(cancelSharedReportEmail, (state, { requestId }) =>
    state.requestId === requestId && state.status !== 'idle' ? initialSharedReportEmailState : state
  ),
  on(createAction(LOGOUT_SUCCESS), () => initialSharedReportEmailState)
);
